module.exports = "\n<app-about-heading></app-about-heading>\n<app-footer></app-footer>"